import { FC, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { Colors, Dropdown, DropdownListItem, FInter, FlexBox, MagicBox, useBreakpoint } from '@brg/ui';
import { UInput } from '../inputs';
import { LayoutConst } from 'core/modules';
import { API, Designer, Endpoints } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import { 
  ModerateCountContainer,
  ModerInfoWrapper,
  SearchBarWrapper, 
  SearchInputsWrapper
} from './styles';
import './styles.css';
import styled, { useTheme, css } from 'styled-components';
import { AppTester } from 'supporting';
import useQueryState from 'shared/hooks/useQueryState';
import { getMonthItems, getYearItems } from './const/dropdownItems';
import { useProfile } from '@brg/auth';
import { format } from 'date-fns';
import { HoverItemWithSvg } from '../projectsSearchBar/style';
import { CreateLinkTo } from 'shared/constants/linkTo';

type UnionT = {
  value: string | number;
  label: string | number;
}

type MagicBoxRowPropsT = {
  onClick: () => void;
  checked: boolean;
  label: string;
  style?: any;
};

export const BetweenItem = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;

  a {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  * {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const DropdownWrapper = styled(FlexBox)`
  .dropdown-button {
    height: auto !important;
  }
  .dropdown-element-popup {
    max-width: 222px;
    min-width: 222px;
    right: -8px;
    box-shadow: none;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      max-width: 155px;
      min-width: 155px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      max-width: none;
      width: calc(100vw - 20px);
      min-width: calc(100vw - 20px);
    }
  }
    width: 100%;
    justify-content: end;

  svg path {
    fill: #151514 !important;
  }
`;

export const SearchDateContainer = styled(FlexBox)<{orientFix?: boolean}>`
width: 100%;

@media(max-width: ${LayoutConst.screen.l_12}px) {
 flex-flow: column;
 justify-content: flex-start;
 place-items: start !important;
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-flow: column;

    label {
        margin-right: 6px;
    }
}


`;

export const DatePickerWrapper = styled(FlexBox)`
  width: ${LayoutConst.projectCard.l.w}px;
  height: 46px;
  max-width: ${LayoutConst.projectCard.l.w}px;
  min-width: ${LayoutConst.projectCard.m.w}px;
  place-items: center;
  margin-right: 24px;
  position: relative;

  .close-modal-mobile {
    position: absolute;
    top: 50%;
    right: 50px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .react-date-picker__button {
    padding-right: 16px;
  }

  .react-date-picker__inputGroup {
    padding: 0 0 0 16px;

    * {
      ::placeholder {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
      }
    }
  }

  .react-date-picker__inputGroup__day[value=''] {
    width: 105px !important;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
  }

  .date-input {
    background-color: ${({ theme }) => theme.tagAdminPage.inputs.bg};
    border-radius: 3px !important;
  }

  .react-date-picker__wrapper {
    border: none !important;
  }

  .date-input.black-theme .react-date-picker__inputGroup__divider::before {
    color: rgba(144, 144, 144, 1) !important
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    width: ${LayoutConst.projectCard.m.w}px;
    margin-right: ${LayoutConst.projectCardGap.m}px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {

    svg {
      width: 16px;
      height: 16px;
    }
    .date-input {
      width: 100% !important;
    }

    margin-right: 24px;
    width: 221.4px;

    .react-date-picker__inputGroup {
      padding: 0 0 0 16px;
  
      * {
        ::placeholder {
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
        }
      }
    }
   
    .react-date-picker__inputGroup__day[value=''] {
      position: absolute;
      top: 50%;
      left: 16px;
      width: 130px !important;
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.02em;
      transform: translateY(-50%);
      z-index: 2;
    }
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0;
    margin-bottom: 8px;
    height: 46px;
    width: 100%;
    max-width: 100%;
  }

`;

const DropDownWrapper = styled(FlexBox)`
  // width: 122px;
  // min-width: 122px;
  width: 157px;
  min-width: 157px;
  height: 46px;
  cursor: pointer;

  .brg-input__single-value {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.tagAdminPage.select.color};
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    width: auto;
    place-items: center;
    justify-content: space-between;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    .brg-input__single-value {
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.02em;
    }
  }
  @media(max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
    min-width: auto;
    place-items: center;

  }

  .brg-input__menu-list {
    max-height: 272px;
  }

  .brg-input__menu-list > .brg-input__option {
    color: #70706F;
  }

  .brg-input__menu-list > .brg-input__option--is-selected {
    color: #70706F !important;
  }

  .brg-input__menu-list > .brg-input__option--is-selected {
    color: #70706F !important;
  }

`;

export const CheckboxRoot = styled.div<{ checked?: boolean, isContinuumSite?: boolean, isHSEDesign?: boolean, props: any }>`
  width: 24px;
  height: 24px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    display: none;
  }

  ${({ props }) => props && css`${props}`};
`

const MagicBoxLabel = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
  @media (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

const objValue = (val: string | number) => 
  ({ value: val, label: val })

export const MagicBoxRow: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, style }) => {
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const theme = useTheme();
  const isHSEDesign = AppTester.isHSEDesign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isCgRave = AppTester.isCGRAVE();

  const magicBoxRowStyle = { paddingRight: is1280 ? 32 : 48, height: /*'44px'*/ 24, /*paddingTop: '20px', */paddingBottom: '0' };

  const checkboxStyles = useMemo(() => {
    if (isHSEDesign) {
      return {
        border: `1px solid ${theme.competition.input.checkbox.border}`,
        backgroundColor: theme.competition.input.checkbox.bg,
        svg: {
          path: {
            fill: theme.competition.input.checkbox.icon
          }
        }
      }
    }

    return {
      border: `1px solid ${theme.competition.input.checkbox.border}`,
      backgroundColor: theme.approvalBlockStyles.bg,
      svg: {
        path: {
          fill: (
            (isContinuumSite || isCgRave) ? 
            Colors.geoWhite73 : 
            theme.tagAdminPage.select.color
          )
        }
      }
    }
  } , [theme])

  return (
    <MagicBox
    className={'checkboxes'}
    onClick={onClick}
    style={style || magicBoxRowStyle}
    pointer
    align="center"
    gx={is992 ? 8 : 16}
  >
    <CheckboxRoot props={checkboxStyles} checked={checked} isHSEDesign={isHSEDesign} isContinuumSite={isContinuumSite}>
      {checked && <CheckIcon />}
      <input checked={checked} type="checkbox"/>
    </CheckboxRoot>
    <MagicBoxLabel style={{ whiteSpace: "pre" }}>
      {label}
    </MagicBoxLabel>
  </MagicBox>
  )
};

export interface TagAdminProjectsSearchBarProps {
  approved: boolean;
  notApproved: boolean;
  notModerated: boolean;
  temp: boolean;
  moderatedBy: string;
  tagId: string;
  filter: any[];
  onApprovedHsedesign: (value: boolean) => void;
  onNotApprovedHsedesign: (value: boolean) => void;
  onNotModerated: (value: boolean) => void;
  onModeratedBy: (value: string) => void;
  onCreatedFrom: (value: string) => void;
  onMonthChange:(value: string) => void;
  onYearChange: (value: string) => void;
  onCreatedTo: (value: string) => void;
  onTemp: (value: boolean) => void;
  extraFilter?: any;
  filterContent?: ReactNode;
  onExtraFilterChange?: (filter: any) => void;
}

export const TagAdminProjectsSearchBar: FC<TagAdminProjectsSearchBarProps> = (props) => {

  const { t, i18n } = useTranslation();
  const profile = useProfile();
  const theme = useTheme();
  const [{ teachersOnly, createdFrom, createdTo }, setQueryParams] = useQueryState();
  const [selectedUser, setSelectedUser] = useState<{value: string, label: string}>({value: "", label: `${t('select_person')}`});

  const defaultYear = useMemo(() => ({ value: '', label: t('tag_page.inputs.default_year')} ), [ t]);
  const defaultMonth = useMemo(() => ({ value: '', label: t('tag_page.inputs.default_month')} ), [t]);

  const emptyMonth = { value: '', label: '-' };

  const [moderInfoData, setModerInfoData] = useState({
    approvedCount: 0,
    moderatedCount: 0,
    notApprovedCount: 0,
    notModeratedCount: 0,
    otherExperts: []
  }) 
  const is743 = useBreakpoint(LayoutConst.screen.s -1);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isBlackTheme = (AppTester.isGeograffee() && !isDafes ) || AppTester.isSuperPuper();
  const currentYear = new Date()?.getFullYear();
  const isCGrave = AppTester.isCGRAVE()
  const isContinuumSite = AppTester.isContinuumSite()
  const isDarkTheme = (isGeo && !isGeoDafes) || isGameDeziiign || isCGrave || isContinuumSite

  const { year, month } = useMemo(() => {
    if (!!createdFrom?.split('-')?.length) {
      const y = String(createdFrom?.split('-')?.[0]);
      const m = String(createdFrom?.split('-')?.[1]);

      const isEqualMonths = m === createdTo?.split('-')?.[1];

      return { 
        year: objValue(y),
        month: isEqualMonths ? getMonthItems(i18n.language)
        ?.find((i: any) => Number(i?.value) === parseFloat(m) ) 
        : emptyMonth
      }
    }
    return {
      year: defaultYear,
      month: emptyMonth
    }
  } , [createdFrom, createdTo, defaultYear, emptyMonth, i18n.language])

  const [selectedYear, setSelectedYear] = useState<UnionT>(year as UnionT);
  const [selectedMonth, setSelectedMonth] = useState<UnionT>(month as UnionT);

  const breakCheckbox = useMemo(() => (i18n.language === 'ru') || (is992), [isHSEDesign, i18n.language, is992 ])

  const fetchModerInfo = async (currentDate: string, targetDate: string) => {
    const endpoint = Endpoints.geograffee;
    let route = `/api/Moderators/Approves?tagId=${props.tagId}&publishedFrom=${targetDate || ''}&publishedTo=${currentDate || ''} `;

    if (props?.filter) {
      props?.filter?.forEach((s) => ( route+= `&globalTypes=${s}`))
    }

    await API.fetch(endpoint + route, {})
    .then((r) => r.json())
    .then((r) => {
      setModerInfoData({...r})
    })
  }

  const expertsDropdown = useMemo(() => {
    if (
      !moderInfoData?.otherExperts || 
      !moderInfoData?.otherExperts?.length
    ) {
      return null;
    }
    const computeExperts = moderInfoData?.otherExperts?.map(
      (i: { 
        designer: Designer<'Global'>, 
        moderatedCount: number 
      }) => (
        { 
          expert: API.toLang(i?.designer, i18n.language) as Designer<'Local'>, 
          count: i?.moderatedCount
        }
      ));

      const computeExpertsWithownProfile = [...computeExperts].sort((a, b) => b.count - a.count);
  
    return (
      <DropdownWrapper>
        <Dropdown
          offsetArrowX={0}
          offsetY={is743 ? -8 : -4}
          orientation={'right'}
          hideArrow
          target={
            <HoverItemWithSvg color={'#151514'} gx={8}>
              <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                            fill={'#151514'}/>
                  </svg>
            </HoverItemWithSvg>
          }
        >
          {computeExpertsWithownProfile?.map(({ expert, count }) => {
            const computeName = expert?.name + ' ' + expert?.surName;
            const link = CreateLinkTo.designer(expert?.designerId);

            return (
              <DropdownListItem>
                <BetweenItem>
                  <a href={link} target={'_BLANK'}>
                    {computeName}
                  </a>
                  <span>
                    {count}
                  </span>
                </BetweenItem>
              </DropdownListItem>
            )
          })}
        </Dropdown>
      </DropdownWrapper>
    )
  } , [moderInfoData, i18n, theme, is743])

  const ModerInfoBlock = useMemo(() => (
    <ModerInfoWrapper isDarkTheme={isDarkTheme}>
      <span className='text title'>{t('user_statistic')}</span>
      <ModerateCountContainer className={'title-wrapper'} gx={4} gxMobile={4} direction='row' align='center' alignMobile='center' directionMobile='row' wrap={'false'}>
        <>
          {!!moderInfoData?.moderatedCount && <span className='text'>{`${t('own_moder')}`}</span>}
          <span className='value'>{moderInfoData?.moderatedCount || 0}</span>
          {expertsDropdown}
        </>
      </ModerateCountContainer>
        <span className='text'>{`${t('moder_not_approved')}`}</span>
      <FlexBox gx={4} gxMobile={4} direction='row' align='center' alignMobile='center' directionMobile='row' wrap={'false'}>
        <span className='value'>{moderInfoData?.notModeratedCount || 0}</span>
      </FlexBox>
    </ModerInfoWrapper>
  ) , [t, moderInfoData, expertsDropdown])
  
    
    useEffect(() => setSelectedUser({value: "", label: `${t('select_person')}`}), [i18n, i18n.language])

    const daysInMonth = (y: number, m: number) => {
      return 33 - new Date(y, m, 33).getDate();
    };

    useEffect(() => {
      if (profile) {
        const isEmptyMonth = selectedMonth?.value === '';
        const isEmptyYear = selectedYear?.value === '';
        const defaultEmptyYear = new Date()?.getFullYear();
        const defaultEmptyMonth = 12;
        const restMonths = 11;
        //@ts-ignore
        const endMonthDay = daysInMonth(Number(selectedYear?.value), Number(selectedMonth?.value - 1));
        const startMonthDay = '01';

        const finalYear = isEmptyYear ? defaultEmptyYear : selectedYear?.value;
        const cMonth = isEmptyMonth ? defaultEmptyMonth : selectedMonth?.value;
        const tMonth = isEmptyMonth ? (defaultEmptyMonth - restMonths) : selectedMonth?.value;
        
        const current = format(new Date( `${finalYear}-${String(cMonth).length < 2 ? '0' + cMonth : cMonth}-${endMonthDay}` ), 'yyyy-MM-dd');
        const target =  format(new Date( `${finalYear}-${String(tMonth).length < 2 ? '0' + tMonth : tMonth}-${startMonthDay}` ), 'yyyy-MM-dd');

        const currentDateString = current
        const targetDateString = target

        if (!isEmptyYear || !isEmptyMonth) {
          fetchModerInfo(
            currentDateString, 
            targetDateString
          );

          setQueryParams(
            { 
              createdFrom: targetDateString, 
              createdTo: currentDateString
            }, 
            { 
              replace: true 
            }
          )
        } else {
          fetchModerInfo('', '');
        }
      }
    } , [selectedYear, selectedMonth, profile])
  
    const handleApprovedHsedesign = useCallback(() => {
        props.onApprovedHsedesign(!props.approved);
    }, [props]);

    const handleNotApprovedHsedesign = useCallback(() => {
        props.onNotApprovedHsedesign(!props.notApproved);
    }, [props]);

    const handleNotModerated = useCallback(() => {
        props.onNotModerated(!props.notModerated);
    }, [props]);

    const handleTemp = useCallback(() => {
      props.onTemp(!props.temp);
    }, [props]);


    const onMonthChange = useCallback((data: any) => {
      if (selectedYear?.value === '') {
        setSelectedYear(objValue(currentYear))
      }

      setSelectedMonth(data)
    },[props, selectedYear, currentYear])

    const onYearChange = useCallback((data: any) => {
      setSelectedYear(data)
      if (data?.value === '') {
        setQueryParams(
          { 
            createdFrom: '', 
            createdTo: ''
          }, 
          { 
            replace: true 
          }
        )
      } else if (selectedMonth?.value === '') {
        setSelectedMonth(emptyMonth)
      }

    },[props, selectedMonth])

  return (
    <SearchBarWrapper orientFix width={'100%'} isTagPage>
        <FlexBox flex="1" justify="space-between" align="flex-end" width="100%" directionMobile='column'>
            <FlexBox align="flex-end" gx={24} width="100%">
                <FlexBox width="100%">
                    <SearchInputsWrapper column={true}>
                      <SearchDateContainer style={{ placeItems: 'end' }} directionMobile={is743 ? 'column' : 'row'} orientFix>
                        <FlexBox widthMobile={'100%'} gx={16} gxMobile={is743 ? 1 : 16} direction='row' directionMobile={is743 ? 'column' : 'row'}>
                          <DropDownWrapper>
                            <UInput.Dropdown
                              value={selectedYear}
                              onChange={onYearChange}               
                              options={[defaultYear, ...getYearItems()]}
                              custom={{
                                customHeight: is1280 ? '39px' : '46px',
                                customBackgroundColor: isBlackTheme ? "#3F4548" : '#f2f2f2',
                                customBorderColor: isBlackTheme ? 'transparent' : '#B6B6B5',
                                customBorderColorHover: isBlackTheme ? 'transparent' : '#B6B6B5',
                                customTextColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : (selectedUser?.value === '' ? '#909090' : '#151514'),
                                customPlaceholderColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : '#909090'
                              }}
                            />
                          </DropDownWrapper>
                          <DropDownWrapper>
                            <UInput.Dropdown
                                value={selectedMonth}
                                onChange={onMonthChange}
                                options={[defaultMonth, ...getMonthItems(i18n.language)]}
                                custom={{
                                  customHeight: is1280 ? '39px' : '46px',
                                  customBackgroundColor: isBlackTheme ? "#3F4548" : '#f2f2f2',
                                  customBorderColor: isBlackTheme ? 'transparent' : '#B6B6B5',
                                  customBorderColorHover: isBlackTheme ? 'transparent' : '#B6B6B5',
                                  customTextColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : (selectedUser?.value === '' ? '#909090' : '#151514'),
                                  customPlaceholderColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : '#909090'
                                }}
                            />
                          </DropDownWrapper>
                        </FlexBox>
                        {ModerInfoBlock}
                      </SearchDateContainer>
                  </SearchInputsWrapper>
                </FlexBox>
            </FlexBox>
        </FlexBox>
        <FlexBox flex="1" justify="space-between" align="flex-end" width={'100%'}>
            <FlexBox align="flex-end" justify='space-between' gx={24} width={'100%'} offsetTop={34} offsetTopMobile={24} offsetBottomMobile={0}>
                <SearchInputsWrapper width={'100%'} style={{ flexWrap: 'wrap' }} breakCheckbox={breakCheckbox}>
                    <MagicBoxRow label={t('checkbox_filter.approve')} checked={props.approved} onClick={handleApprovedHsedesign} />
                    <MagicBoxRow label={t('checkbox_filter.not_approve')} checked={props.notApproved} onClick={handleNotApprovedHsedesign}/>
                    <MagicBoxRow label={t('checkbox_filter.not_moder')} checked={props.notModerated} onClick={handleNotModerated}/>
                    {isHSEDesign && <MagicBoxRow label={t('checkbox_filter.temp')} checked={props.temp} onClick={handleTemp}/>}
                    {isHSEDesign && (
                      <MagicBoxRow
                        label={t('filter.teacher_projects')}
                        checked={Boolean(teachersOnly)}
                        onClick={() => {
                          props.onExtraFilterChange?.({
                            globalTypes: props?.extraFilter?.globalTypes?.length ? [] : ['employee'],
                          })
                          setQueryParams({ teachersOnly: teachersOnly === 'true' ? '' : 'true' })
                        }}
                      />
                    )}
                </SearchInputsWrapper>
            </FlexBox>
        </FlexBox>
    </SearchBarWrapper>
  );
};
import { FC, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { Colors, Dropdown, DropdownListItem, FInter, FlexBox, MagicBox, useBreakpoint } from '@brg/ui';
import { UInput } from '../inputs';
import { LayoutConst } from 'core/modules';
import { API, Designer, Endpoints } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import { 
  ModerateCountContainer,
  ModerInfoWrapper,
  SearchBarWrapper, 
  SearchInputsWrapper
} from './styles';
import './styles.css';
import styled, { useTheme, css } from 'styled-components';
import { AppTester } from 'supporting';
import useQueryState from 'shared/hooks/useQueryState';
import { getMonthItems, getYearItems } from './const/dropdownItems';
import { useProfile } from '@brg/auth';
import { format } from 'date-fns';
import { HoverItemWithSvg } from '../projectsSearchBar/style';
import { CreateLinkTo } from 'shared/constants/linkTo';

type UnionT = {
  value: string | number;
  label: string | number;
}

type MagicBoxRowPropsT = {
  onClick: () => void;
  checked: boolean;
  label: string;
  style?: any;
};

export const BetweenItem = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;

  a {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  * {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const DropdownWrapper = styled(FlexBox)`
  .dropdown-button {
    height: auto !important;
  }
  .dropdown-element-popup {
    max-width: 222px;
    min-width: 222px;
    right: -8px;
    box-shadow: none;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      max-width: 155px;
      min-width: 155px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      max-width: none;
      width: calc(100vw - 20px);
      min-width: calc(100vw - 20px);
    }
  }
    width: 100%;
    justify-content: end;

  svg path {
    fill: #151514 !important;
  }
`;

export const SearchDateContainer = styled(FlexBox)<{orientFix?: boolean}>`
width: 100%;

@media(max-width: ${LayoutConst.screen.l_12}px) {
 flex-flow: column;
 justify-content: flex-start;
 place-items: start !important;
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-flow: column;

    label {
        margin-right: 6px;
    }
}


`;

export const DatePickerWrapper = styled(FlexBox)`
  width: ${LayoutConst.projectCard.l.w}px;
  height: 46px;
  max-width: ${LayoutConst.projectCard.l.w}px;
  min-width: ${LayoutConst.projectCard.m.w}px;
  place-items: center;
  margin-right: 24px;
  position: relative;

  .close-modal-mobile {
    position: absolute;
    top: 50%;
    right: 50px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .react-date-picker__button {
    padding-right: 16px;
  }

  .react-date-picker__inputGroup {
    padding: 0 0 0 16px;

    * {
      ::placeholder {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
      }
    }
  }

  .react-date-picker__inputGroup__day[value=''] {
    width: 105px !important;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
  }

  .date-input {
    background-color: ${({ theme }) => theme.tagAdminPage.inputs.bg};
    border-radius: 3px !important;
  }

  .react-date-picker__wrapper {
    border: none !important;
  }

  .date-input.black-theme .react-date-picker__inputGroup__divider::before {
    color: rgba(144, 144, 144, 1) !important
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    width: ${LayoutConst.projectCard.m.w}px;
    margin-right: ${LayoutConst.projectCardGap.m}px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {

    svg {
      width: 16px;
      height: 16px;
    }
    .date-input {
      width: 100% !important;
    }

    margin-right: 24px;
    width: 221.4px;

    .react-date-picker__inputGroup {
      padding: 0 0 0 16px;
  
      * {
        ::placeholder {
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
        }
      }
    }
   
    .react-date-picker__inputGroup__day[value=''] {
      position: absolute;
      top: 50%;
      left: 16px;
      width: 130px !important;
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.02em;
      transform: translateY(-50%);
      z-index: 2;
    }
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0;
    margin-bottom: 8px;
    height: 46px;
    width: 100%;
    max-width: 100%;
  }

`;

const DropDownWrapper = styled(FlexBox)`
  // width: 122px;
  // min-width: 122px;
  width: 157px;
  min-width: 157px;
  height: 46px;
  cursor: pointer;

  .brg-input__single-value {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.tagAdminPage.select.color};
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    width: auto;
    place-items: center;
    justify-content: space-between;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    .brg-input__single-value {
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.02em;
    }
  }
  @media(max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
    min-width: auto;
    place-items: center;

  }

  .brg-input__menu-list {
    max-height: 272px;
  }

  .brg-input__menu-list > .brg-input__option {
    color: #70706F;
  }

  .brg-input__menu-list > .brg-input__option--is-selected {
    color: #70706F !important;
  }

  .brg-input__menu-list > .brg-input__option--is-selected {
    color: #70706F !important;
  }

`;

export const CheckboxRoot = styled.div<{ checked?: boolean, isContinuumSite?: boolean, isHSEDesign?: boolean, props: any }>`
  width: 24px;
  height: 24px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    display: none;
  }

  ${({ props }) => props && css`${props}`};
`

const MagicBoxLabel = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
  @media (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

const objValue = (val: string | number) => 
  ({ value: val, label: val })

export const MagicBoxRow: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, style }) => {
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const theme = useTheme();
  const isHSEDesign = AppTester.isHSEDesign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isCgRave = AppTester.isCGRAVE();

  const magicBoxRowStyle = { paddingRight: is1280 ? 32 : 48, height: /*'44px'*/ 24, /*paddingTop: '20px', */paddingBottom: '0' };

  const checkboxStyles = useMemo(() => {
    if (isHSEDesign) {
      return {
        border: `1px solid ${theme.competition.input.checkbox.border}`,
        backgroundColor: theme.competition.input.checkbox.bg,
        svg: {
          path: {
            fill: theme.competition.input.checkbox.icon
          }
        }
      }
    }

    return {
      border: `1px solid ${theme.competition.input.checkbox.border}`,
      backgroundColor: theme.approvalBlockStyles.bg,
      svg: {
        path: {
          fill: (
            (isContinuumSite || isCgRave) ? 
            Colors.geoWhite73 : 
            theme.tagAdminPage.select.color
          )
        }
      }
    }
  } , [theme])

  return (
    <MagicBox
    className={'checkboxes'}
    onClick={onClick}
    style={style || magicBoxRowStyle}
    pointer
    align="center"
    gx={is992 ? 8 : 16}
  >
    <CheckboxRoot props={checkboxStyles} checked={checked} isHSEDesign={isHSEDesign} isContinuumSite={isContinuumSite}>
      {checked && <CheckIcon />}
      <input checked={checked} type="checkbox"/>
    </CheckboxRoot>
    <MagicBoxLabel style={{ whiteSpace: "pre" }}>
      {label}
    </MagicBoxLabel>
  </MagicBox>
  )
};

export interface TagAdminProjectsSearchBarProps {
  approved: boolean;
  notApproved: boolean;
  notModerated: boolean;
  temp: boolean;
  moderatedBy: string;
  tagId: string;
  filter: any[];
  onApprovedHsedesign: (value: boolean) => void;
  onNotApprovedHsedesign: (value: boolean) => void;
  onNotModerated: (value: boolean) => void;
  onModeratedBy: (value: string) => void;
  onCreatedFrom: (value: string) => void;
  onMonthChange:(value: string) => void;
  onYearChange: (value: string) => void;
  onCreatedTo: (value: string) => void;
  onTemp: (value: boolean) => void;
  extraFilter?: any;
  filterContent?: ReactNode;
  onExtraFilterChange?: (filter: any) => void;
}

export const TagAdminProjectsSearchBar: FC<TagAdminProjectsSearchBarProps> = (props) => {

  const { t, i18n } = useTranslation();
  const profile = useProfile();
  const theme = useTheme();
  const [{ teachersOnly, createdFrom, createdTo }, setQueryParams] = useQueryState();
  const [selectedUser, setSelectedUser] = useState<{value: string, label: string}>({value: "", label: `${t('select_person')}`});

  const defaultYear = useMemo(() => ({ value: '', label: t('tag_page.inputs.default_year')} ), [ t]);
  const defaultMonth = useMemo(() => ({ value: '', label: t('tag_page.inputs.default_month')} ), [t]);

  const emptyMonth = { value: '', label: '-' };

  const [moderInfoData, setModerInfoData] = useState({
    approvedCount: 0,
    moderatedCount: 0,
    notApprovedCount: 0,
    notModeratedCount: 0,
    otherExperts: []
  }) 
  const is743 = useBreakpoint(LayoutConst.screen.s -1);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isBlackTheme = (AppTester.isGeograffee() && !isDafes ) || AppTester.isSuperPuper();
  const currentYear = new Date()?.getFullYear();
  const isCGrave = AppTester.isCGRAVE()
  const isContinuumSite = AppTester.isContinuumSite()
  const isDarkTheme = (isGeo && !isGeoDafes) || isGameDeziiign || isCGrave || isContinuumSite

  const { year, month } = useMemo(() => {
    if (!!createdFrom?.split('-')?.length) {
      const y = String(createdFrom?.split('-')?.[0]);
      const m = String(createdFrom?.split('-')?.[1]);

      const isEqualMonths = m === createdTo?.split('-')?.[1];

      return { 
        year: objValue(y),
        month: isEqualMonths ? getMonthItems(i18n.language)
        ?.find((i: any) => Number(i?.value) === parseFloat(m) ) 
        : emptyMonth
      }
    }
    return {
      year: defaultYear,
      month: emptyMonth
    }
  } , [createdFrom, createdTo, defaultYear, emptyMonth, i18n.language])

  const [selectedYear, setSelectedYear] = useState<UnionT>(year as UnionT);
  const [selectedMonth, setSelectedMonth] = useState<UnionT>(month as UnionT);

  const breakCheckbox = useMemo(() => (i18n.language === 'ru') || (is992), [isHSEDesign, i18n.language, is992 ])

  const fetchModerInfo = async (currentDate: string, targetDate: string) => {
    const endpoint = Endpoints.geograffee;
    let route = `/api/Moderators/Approves?tagId=${props.tagId}&publishedFrom=${targetDate || ''}&publishedTo=${currentDate || ''} `;

    if (props?.filter) {
      props?.filter?.forEach((s) => ( route+= `&globalTypes=${s}`))
    }

    await API.fetch(endpoint + route, {})
    .then((r) => r.json())
    .then((r) => {
      setModerInfoData({...r})
    })
  }

  const expertsDropdown = useMemo(() => {
    if (
      !moderInfoData?.otherExperts || 
      !moderInfoData?.otherExperts?.length
    ) {
      return null;
    }
    const computeExperts = moderInfoData?.otherExperts?.map(
      (i: { 
        designer: Designer<'Global'>, 
        moderatedCount: number 
      }) => (
        { 
          expert: API.toLang(i?.designer, i18n.language) as Designer<'Local'>, 
          count: i?.moderatedCount
        }
      ));

      const computeExpertsWithownProfile = [...computeExperts].sort((a, b) => b.count - a.count);
  
    return (
      <DropdownWrapper>
        <Dropdown
          offsetArrowX={0}
          offsetY={is743 ? -8 : -4}
          orientation={'right'}
          hideArrow
          target={
            <HoverItemWithSvg color={'#151514'} gx={8}>
              <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                            fill={'#151514'}/>
                  </svg>
            </HoverItemWithSvg>
          }
        >
          {computeExpertsWithownProfile?.map(({ expert, count }) => {
            const computeName = expert?.name + ' ' + expert?.surName;
            const link = CreateLinkTo.designer(expert?.designerId);

            return (
              <DropdownListItem>
                <BetweenItem>
                  <a href={link} target={'_BLANK'}>
                    {computeName}
                  </a>
                  <span>
                    {count}
                  </span>
                </BetweenItem>
              </DropdownListItem>
            )
          })}
        </Dropdown>
      </DropdownWrapper>
    )
  } , [moderInfoData, i18n, theme, is743])

  const ModerInfoBlock = useMemo(() => (
    <ModerInfoWrapper isDarkTheme={isDarkTheme}>
      <span className='text title'>{t('user_statistic')}</span>
      <ModerateCountContainer className={'title-wrapper'} gx={4} gxMobile={4} direction='row' align='center' alignMobile='center' directionMobile='row' wrap={'false'}>
        <>
          {!!moderInfoData?.moderatedCount && <span className='text'>{`${t('own_moder')}`}</span>}
          <span className='value'>{moderInfoData?.moderatedCount || 0}</span>
          {expertsDropdown}
        </>
      </ModerateCountContainer>
        <span className='text'>{`${t('moder_not_approved')}`}</span>
      <FlexBox gx={4} gxMobile={4} direction='row' align='center' alignMobile='center' directionMobile='row' wrap={'false'}>
        <span className='value'>{moderInfoData?.notModeratedCount || 0}</span>
      </FlexBox>
    </ModerInfoWrapper>
  ) , [t, moderInfoData, expertsDropdown])
  
    
    useEffect(() => setSelectedUser({value: "", label: `${t('select_person')}`}), [i18n, i18n.language])

    const daysInMonth = (y: number, m: number) => {
      return 33 - new Date(y, m, 33).getDate();
    };

    useEffect(() => {
      if (profile) {
        const isEmptyMonth = selectedMonth?.value === '';
        const isEmptyYear = selectedYear?.value === '';
        const defaultEmptyYear = new Date()?.getFullYear();
        const defaultEmptyMonth = 12;
        const restMonths = 11;
        //@ts-ignore
        const endMonthDay = daysInMonth(Number(selectedYear?.value), Number(selectedMonth?.value - 1));
        const startMonthDay = '01';

        const finalYear = isEmptyYear ? defaultEmptyYear : selectedYear?.value;
        const cMonth = isEmptyMonth ? defaultEmptyMonth : selectedMonth?.value;
        const tMonth = isEmptyMonth ? (defaultEmptyMonth - restMonths) : selectedMonth?.value;
        
        const current = format(new Date( `${finalYear}-${String(cMonth).length < 2 ? '0' + cMonth : cMonth}-${endMonthDay}` ), 'yyyy-MM-dd');
        const target =  format(new Date( `${finalYear}-${String(tMonth).length < 2 ? '0' + tMonth : tMonth}-${startMonthDay}` ), 'yyyy-MM-dd');

        const currentDateString = current
        const targetDateString = target

        if (!isEmptyYear || !isEmptyMonth) {
          fetchModerInfo(
            currentDateString, 
            targetDateString
          );

          setQueryParams(
            { 
              createdFrom: targetDateString, 
              createdTo: currentDateString
            }, 
            { 
              replace: true 
            }
          )
        } else {
          fetchModerInfo('', '');
        }
      }
    } , [selectedYear, selectedMonth, profile])
  
    const handleApprovedHsedesign = useCallback(() => {
        props.onApprovedHsedesign(!props.approved);
    }, [props]);

    const handleNotApprovedHsedesign = useCallback(() => {
        props.onNotApprovedHsedesign(!props.notApproved);
    }, [props]);

    const handleNotModerated = useCallback(() => {
        props.onNotModerated(!props.notModerated);
    }, [props]);

    const handleTemp = useCallback(() => {
      props.onTemp(!props.temp);
    }, [props]);


    const onMonthChange = useCallback((data: any) => {
      if (selectedYear?.value === '') {
        setSelectedYear(objValue(currentYear))
      }

      setSelectedMonth(data)
    },[props, selectedYear, currentYear])

    const onYearChange = useCallback((data: any) => {
      setSelectedYear(data)
      if (data?.value === '') {
        setQueryParams(
          { 
            createdFrom: '', 
            createdTo: ''
          }, 
          { 
            replace: true 
          }
        )
      } else if (selectedMonth?.value === '') {
        setSelectedMonth(emptyMonth)
      }

    },[props, selectedMonth])

  return (
    <SearchBarWrapper orientFix width={'100%'} isTagPage>
        <FlexBox flex="1" justify="space-between" align="flex-end" width="100%" directionMobile='column'>
            <FlexBox align="flex-end" gx={24} width="100%">
                <FlexBox width="100%">
                    <SearchInputsWrapper column={true}>
                      <SearchDateContainer style={{ placeItems: 'end' }} directionMobile={is743 ? 'column' : 'row'} orientFix>
                        <FlexBox widthMobile={'100%'} gx={16} gxMobile={is743 ? 1 : 16} direction='row' directionMobile={is743 ? 'column' : 'row'}>
                          <DropDownWrapper>
                            <UInput.Dropdown
                              value={selectedYear}
                              onChange={onYearChange}               
                              options={[defaultYear, ...getYearItems()]}
                              custom={{
                                customHeight: is1280 ? '39px' : '46px',
                                customBackgroundColor: isBlackTheme ? "#3F4548" : '#f2f2f2',
                                customBorderColor: isBlackTheme ? 'transparent' : '#B6B6B5',
                                customBorderColorHover: isBlackTheme ? 'transparent' : '#B6B6B5',
                                customTextColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : (selectedUser?.value === '' ? '#909090' : '#151514'),
                                customPlaceholderColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : '#909090'
                              }}
                            />
                          </DropDownWrapper>
                          <DropDownWrapper>
                            <UInput.Dropdown
                                value={selectedMonth}
                                onChange={onMonthChange}
                                options={[defaultMonth, ...getMonthItems(i18n.language)]}
                                custom={{
                                  customHeight: is1280 ? '39px' : '46px',
                                  customBackgroundColor: isBlackTheme ? "#3F4548" : '#f2f2f2',
                                  customBorderColor: isBlackTheme ? 'transparent' : '#B6B6B5',
                                  customBorderColorHover: isBlackTheme ? 'transparent' : '#B6B6B5',
                                  customTextColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : (selectedUser?.value === '' ? '#909090' : '#151514'),
                                  customPlaceholderColor: isBlackTheme ? 'rgba(144, 144, 144, 1)' : '#909090'
                                }}
                            />
                          </DropDownWrapper>
                        </FlexBox>
                        {ModerInfoBlock}
                      </SearchDateContainer>
                  </SearchInputsWrapper>
                </FlexBox>
            </FlexBox>
        </FlexBox>
        <FlexBox flex="1" justify="space-between" align="flex-end" width={'100%'}>
            <FlexBox align="flex-end" justify='space-between' gx={24} width={'100%'} offsetTop={34} offsetTopMobile={24} offsetBottomMobile={0}>
                <SearchInputsWrapper width={'100%'} style={{ flexWrap: 'wrap' }} breakCheckbox={breakCheckbox}>
                    <MagicBoxRow label={t('checkbox_filter.approve')} checked={props.approved} onClick={handleApprovedHsedesign} />
                    <MagicBoxRow label={t('checkbox_filter.not_approve')} checked={props.notApproved} onClick={handleNotApprovedHsedesign}/>
                    <MagicBoxRow label={t('checkbox_filter.not_moder')} checked={props.notModerated} onClick={handleNotModerated}/>
                    {isHSEDesign && <MagicBoxRow label={t('checkbox_filter.temp')} checked={props.temp} onClick={handleTemp}/>}
                    {isHSEDesign && (
                      <MagicBoxRow
                        label={t('filter.teacher_projects')}
                        checked={Boolean(teachersOnly)}
                        onClick={() => {
                          props.onExtraFilterChange?.({
                            globalTypes: props?.extraFilter?.globalTypes?.length ? [] : ['employee'],
                          })
                          setQueryParams({ teachersOnly: teachersOnly === 'true' ? '' : 'true' })
                        }}
                      />
                    )}
                </SearchInputsWrapper>
            </FlexBox>
        </FlexBox>
    </SearchBarWrapper>
  );
};
